export default __webpack_public_path__ + "static/media/lunch5.1873e086.png";